import React, { useContext, useEffect, useState } from "react";
import { JSDCContext, JSDCProvider } from "jsdc-dui/dist/JSDC/Context";
import JSDC from "jsdc-dui/dist/JSDC";
import { latLng, latLngBounds } from "leaflet";
import {
  IDuiContextProviderProps,
  DuiContextProvider,
  DuiContext, //! 數位集章功能
} from "jsdc-dui/dist/components/Context";
import DguideWalksApp from "jsdc-dui/dist/components/DguideWalksApp";
import { DguidewalksProvider } from "jsdc-dui/dist/JSDC/Dguidewalks/Context";
import "jsdc-dui/dist/style/index.css";
import "./index.scss";
import ConfigProvider from "jsdc-dui/dist/JSDC/Dguidewalks/ConfigProvider";
import MenuItemWithDialog from "jsdc-dui/dist/components/LeftMenuBar/MenuList/MenuItemWithDialog";
import Checkin from "jsdc-dui/dist/components/Icons/Checkin";
import headerImg from "./assets/key-art.svg";
import headerImgMb from "./assets/key-art_mobile.jpg";
import aboutImg from "./assets/about.jpg";

const EVENT_ID = "n0016";

//TODO: aboutWalkContent
const aboutWalkContent = `新莊老街被譽為清代前期的「北臺第一街」，是重要商業聚落，也因聚落繁盛，造就許多信仰中心的所在，而有所謂「廟街」的稱號，舊讓我們從慈祐宮出發，領略往昔千帆林立的繁華，走過五十六坎，穿梭在挑水巷、米市巷、戲館巷，體會在地人家的生活日常，更走訪武聖廟、廣福宮、文昌祠，感受傳統信仰的魅力，當然更不能忘記品嘗在地的好味道，阿瑞關的草仔粿、金和合的繼光餅以及老順香的金牌鳳梨酥，期待您漫步在其中，一同走入歷史的時光隧道。
`;

const credit = `
<div>
  團隊介紹：新北市政府教育局新課綱行動協作平臺，聯絡電話(02)29559019
  <br><br>
  <ul>
    <li style="list-style-type: cjk-ideographic;">
      本圖臺是由新北市政府教育局及智紳數位文化有限公司共同協力建置：
      <br>
      <br>1. 圖臺內容：新北市政府教育局
      <br>
      <br>2. 圖臺系統開發：智紳數位文化事業有限公司
    </li><br>
    <li style="list-style-type: cjk-ideographic;">
      除另有聲明外，本網站內容採用創用 CC 姓名標示-非商業性-相同方式分享4.0授權條款授權公眾使用，您可以依授權條款複製、引用、轉載，唯請於合理位置標示本站網址：新北市政府教育局
      <a href="https://www.ntpc.edu.tw/" target="_blank">https://www.ntpc.edu.tw/</a>
    </li>
  </ul>
</div>
`;

const duiConfigProps: IDuiContextProviderProps = {
  sidebarTitle: "",
  sidebarSubtitle: "",
  aboutWalkImgSrc: aboutImg,
  aboutWalkContent,
  credit,
  creditHref: "https://www.facebook.com/JRSHENDigitalCulture/",
  headerMBImgSrc: headerImgMb,
  headerDImgSrc: headerImg,
  menuSwitchItems: [{ id: "數位集章", name: "數位集章" }],
  weatherConfig: {
    token: "CWB-232A270E-12F1-4381-B9F2-DF2D2670A077",
    locations: [{ county: "新北市", town: "新莊區" }], //TODO: weather 氣象預測地點
  },
  themeConfig: {
    "--dui-primary": "#b092bd", //TODO: theme
    "--dui-accent": "#932db2", //TODO: 數位集章按鈕
    "--dui-secondary": "#b092bd", //TODO: theme (--dui-primary)
    "--dui-bg-secondary": "#ffc361", // Dialog background
    "--dui-bg-accent": "#ded2e4", //TODO: background
  },
  settingConfig: {
    disabled: true, // 左側選單不出現「工具設定」
    // languageSwitcherDisabled: true, // 或：保留「工具設定」，只藏語言切換器
  },
};
// #e4e7cb
// 景點的 icon、點擊開集章卡片、cluster、集章 key、`?id=` 深連結、
// 列表的定位與導航、底圖、線都由 jsdc-dui 依 Strapi 的資料建立，這裡不需要再處理圖層。
function App() {
  const { Jsdc } = useContext(JSDCContext);
  const dui = useContext(DuiContext); //! 數位集章功能

  useEffect(() => {
    (window as any).JSDC = Jsdc;
  }, [Jsdc]);

  return (
    <div className="root">
      <DguideWalksApp
        language="zh-TW"
        //! 左側數位集章選項
        mainMenuChildren={
          <MenuItemWithDialog
            Icon={Checkin}
            title="數位集章"
            active={dui.activeMenuId === "數位集章"}
            {...dui.menuSwitcherAction("數位集章")}
          >
            {dui.activeMenuId === "數位集章" && (
              <iframe
                title="數位集章"
                style={{ height: "100%", border: 0, borderRadius: "5px" }}
                src={`https://map.jsdc.com.tw/tools/checkin/${EVENT_ID}/showlist.php?a=${EVENT_ID}`}
              ></iframe>
            )}
          </MenuItemWithDialog>
        }
      />
    </div>
  );
}

const config = new ConfigProvider({ eventId: EVENT_ID });

const AppWrapper: React.FC = () => {
  const [Jsdc] = useState(
    new JSDC(EVENT_ID, {
      bound: latLngBounds(
        //TODO: map view bound
        latLng(25.039000627964928, 121.45927516902523),
        latLng(25.0306431903768, 121.44620468029036),
      ),
      maxZoom: 20,
    }),
  );

  return (
    <JSDCProvider Jsdc={Jsdc}>
      <DguidewalksProvider
        Jsdc={Jsdc}
        config={config}
      >
        <DuiContextProvider {...duiConfigProps}>
          <App />
        </DuiContextProvider>
      </DguidewalksProvider>
    </JSDCProvider>
  );
};

export default AppWrapper;
